import React from "react";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader page-center"></div>
    </div>
  );
};

export default Loader;